const ResultIllustration = (props) => (
  <svg
    width={463}
    height={1080}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M166.852 799.543c-38.721 0-77.062 8.372-112.835 24.639-35.773 16.267-68.277 40.109-95.657 70.166-27.38 30.057-49.098 65.74-63.916 105.011C-120.373 1038.63-128 1080.72-128 1123.23h294.852V799.543Z"
      fill="#D6FEAE"
    />
    <path
      d="M167.186 961.017c-19.391 0-38.593 4.193-56.509 12.339-17.915 8.147-34.194 20.087-47.906 35.144-13.712 15.05-24.589 32.92-32.01 52.59-7.42 19.66-11.24 40.74-11.24 62.03h147.665V961.017Z"
      fill="#000"
    />
    <path
      d="M168 961.228c38.721 0 77.062-8.373 112.835-24.639 35.773-16.267 68.277-40.11 95.657-70.166 27.379-30.057 49.098-65.74 63.916-105.011 14.817-39.272 22.444-81.362 22.444-123.869H168v323.685Z"
      fill="#5171A5"
    />
    <path
      d="M167.361 799.211c19.392 0 38.594-4.193 56.51-12.34 17.915-8.146 34.194-20.087 47.906-35.14 13.712-15.053 24.589-32.923 32.01-52.59 7.421-19.668 11.24-40.748 11.24-62.036H167.361v162.106Z"
      fill="#F1C8DB"
    />
    <path fill="#5171A5" d="M167-73h296v711H167z" />
  </svg>
);

export default ResultIllustration;
